import { render, staticRenderFns } from "./page-multiplayer.vue?vue&type=template&id=3cc87ec2&"
import script from "./page-multiplayer.vue?vue&type=script&lang=js&"
export * from "./page-multiplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports